import {createBrowserHistory} from 'history'

// outside initialization of history for Router for use in outside of components
const browserHistory = createBrowserHistory()

export default browserHistory
